import { AppLayout, Box } from '@amzn/awsui-components-core';
import React from 'react';
import { Router } from 'react-router-dom';
import constants from '../../common/constants';
import { withAppContext } from '../../contexts/AppContext';
import AppContextProps from '../../contexts/AppContextProps';
import BrowserHistory from '../utils/BrowserHistory';
import Footer from './Footer';
import Header from './Header';

const MaintenanceInfo: React.FC<AppContextProps> = ({ appContext }) => {
  const content = (
    <Box>
      <Box color="text-status-inactive" fontSize="display-l" padding={{ top: 'm', bottom: 's' }}>
        {constants.MAINTENANCE_INFO_APG_UPGRADE_HEADER_MESSAGE}
      </Box>
      <Box fontSize="heading-xl" color="text-status-inactive">
        {constants.MAINTENANCE_INFO_MESSAGE_1}
      </Box>
      <Box fontSize="heading-xl" color="text-status-inactive">
        {constants.MAINTENANCE_INFO_MESSAGE_2}
      </Box>
    </Box>
  );

  return (
    <Router history={BrowserHistory}>
      <div className={'site-container'}>
        <Header auth={{}} />
        <main className="awsui main-content">
          <AppLayout
            navigationHide
            toolsHide
            headerSelector={'#page-header'}
            content={content}
            ariaLabels={{
              navigation: 'Navigation',
              tools: 'Help panel',
            }}
          />
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default withAppContext(MaintenanceInfo);
